export var REDRAW_BIT = 1;
export var STYLE_CHANGED_BIT = 2;
export var SHAPE_CHANGED_BIT = 4;



//////////////////
// WEBPACK FOOTER
// ./~/echarts/~/zrender/lib/graphic/constants.js
// module id = 176
// module chunks = 1